import { Routes, Route, useLocation } from "react-router-dom"; // Retire BrowserRouter d'ici
import React, { useState, useEffect } from "react";
import "./styles.css";
import Admin from "./pages/Admin";

// --- IMPORT DES COMPOSANTS ---
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import CookiePopup from "./components/CookiePopup";
import AdminDashboard from "./components/AdminDashboard";

// --- IMPORT DES PAGES ---
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Reviews from "./pages/Reviews";
import ReviewDetails from "./pages/ReviewDetails";
import ArticleDetails from "./pages/ArticleDetails";
import NewsDetails from "./pages/NewsDetails";
import CategoryPage from "./pages/CategoryPage";
import Legal from "./pages/Legal";
import Privacy from "./pages/Privacy";
import Blog from "./pages/Blog";
import Profile from "./pages/Profile";
import GameDetails from "./pages/GameDetails";
import BlogDetail from "./pages/BlogDetail";

// --- COMPOSANT POUR REMONTER EN HAUT ---
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [theme, setTheme] = useState("dark");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
  document.body.className = theme === "light" ? "light-mode" : "";
}, [theme]);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <div className={theme}>
      {/* ON SUPPRIME <Router> ICI car il est déjà dans index.js */}
      <ScrollToTop />
      
      {loading ? (
        <Loader />
      ) : (
        <>
          <Header toggleTheme={toggleTheme} currentTheme={theme} />
          <CookiePopup />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin-pulse" element={<Admin />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/game/:id" element={<GameDetails />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin-secret-portal-ly" element={<AdminDashboard />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />            <Route path="/legal" element={<Legal />} />
            <Route path="/category/:platform" element={<CategoryPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/reviews/:id" element={<ReviewDetails />} />
            <Route path="/news/:id" element={<NewsDetails />} />
            <Route path="/article/:slug" element={<ArticleDetails />} />
          </Routes>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;